module.exports = __webpack_public_path__ + "static/grofalex-443e6b84d56fa9056b1d0b140fb00d02.jpg";